import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from "react";
import getClassNameFactory from "../../utilities/classNames";
import SiteHeader from "./SiteHeader";
import { elementAttributesToProps } from "@tr-digital/react-rehydrate";

var coveoSearch = function coveoSearch() {
  var coveoprops = document.querySelector("header .tr-CoveoSearchBox");

  if (coveoprops) {
    var coveoPropsAttributes = elementAttributesToProps(coveoprops);
    return coveoPropsAttributes;
  }

  return null;
};

var rehydrator = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(domNode, rehydrateChildren) {
    var getClassName, childrenNode, reactifiedChildren, logoLinkNode, siteNameNode, navigationNode, props;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            getClassName = getClassNameFactory("SiteHeader");
            childrenNode = domNode.querySelector(".".concat(getClassName({
              descendantName: "menus"
            })));
            _context.next = 4;
            return rehydrateChildren(childrenNode);

          case 4:
            reactifiedChildren = _context.sent;
            logoLinkNode = domNode.querySelector("a.".concat(getClassName({
              descendantName: "logo"
            })));
            siteNameNode = domNode.querySelector(".".concat(getClassName({
              descendantName: "siteName"
            })));
            navigationNode = domNode.querySelector(".".concat(getClassName({
              descendantName: "inner"
            })));
            props = {
              logoHref: logoLinkNode.href,
              search: domNode.getAttribute("data-search") === "true",
              logoText: logoLinkNode.textContent,
              isPrideMonth: logoLinkNode.getAttribute("data-is-pride-logo-enabled") === "true",
              searchFormAction: domNode.getAttribute("data-search-form-action") || "",
              searchFormMethod: domNode.getAttribute("data-search-form-method"),
              searchInputName: domNode.getAttribute("data-search-input-name"),
              siteName: siteNameNode ? siteNameNode.innerText : "",
              typeaheadUrl: domNode.getAttribute("data-typeahead-url") || "",
              children: reactifiedChildren,
              NavigationAriaTag: navigationNode.localName,
              role: domNode.getAttribute("role") || "none",
              menuRole: childrenNode ? childrenNode.getAttribute("role") : "none",
              placeholder: domNode.getAttribute("data-placeholder") || "Search",
              isCoveoSearchEnabled: domNode.getAttribute("data-is-coveo-search-enabled") === "true",
              isCoveoSearchHeadlessEnabled: domNode.getAttribute("data-is-coveo-search-headless-enabled") === "true",
              coveoSearchBox: coveoSearch()
            };
            return _context.abrupt("return", /*#__PURE__*/React.createElement(SiteHeader, props));

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function rehydrator(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

export default rehydrator;